export const REMOVE_BUTTON_AREA_HEIGHT = '90px';
export const REMOVE_BUTTON_KEY = 'Remove';
